import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Dashboard from '../pages/DashboardTalent/Dashboard';
import CreateInvoice from '../pages/InvoicesTalent/CreateInvoice/CreateInvoice';
import DraftInvoice from '../pages/InvoicesTalent/CreateInvoice/DraftInvoice';
import InvoiceDetails from '../pages/InvoicesTalent/InvoiceDetails/InvoiceDetails';
import Invoices from '../pages/InvoicesTalent/InvoicesList';
import Profile from '../pages/Profile/Profile';
import ProjectDetails from '../pages/Projects/ProjectDetails/ProjectDetails';
import Projects from '../pages/ProjectsTalent/Projects';
import {
  CREATE_INVOICES,
  DASHBOARD,
  DRAFT_INVOICE,
  INVOICES,
  PROFILE,
  PROJECTS
} from './constants';

const TalentRouterConfig = (): JSX.Element => {
  return (
    <Routes>
      <Route path={DASHBOARD} element={<Dashboard />} />
      <Route path={PROJECTS} element={<Projects />} />
      <Route path={`${PROJECTS}/:id`} element={<ProjectDetails />} />
      <Route path={PROFILE} element={<Profile />} />
      <Route path={INVOICES} element={<Invoices />} />
      <Route path={`${INVOICES}/:id`} element={<InvoiceDetails />} />
      <Route path={CREATE_INVOICES} element={<CreateInvoice />} />
      <Route path={`${CREATE_INVOICES}/:id`} element={<CreateInvoice />} />
      <Route path={`${DRAFT_INVOICE}/:id`} element={<DraftInvoice />} />
      <Route
        path={`${CREATE_INVOICES}/:id/:closeProject`}
        element={<CreateInvoice />}
      />
      <Route path={'*'} element={<Navigate to={DASHBOARD} />} />
    </Routes>
  );
};

export default TalentRouterConfig;
